import { ModalContainer } from "@kanda-libs/ks-component-ts";
import type { FunctionComponent } from "react";
import CompanyDeclineModalForm from "components/company/CompanyDeclineModal/CompanyDeclineModalForm";
import { MODAL_ID } from "components/company/CompanyDeclineModal/constants";

export interface CompanyDeclineModalProps {}

const CompanyDeclineModal: FunctionComponent<CompanyDeclineModalProps> =
  function () {
    return (
      <ModalContainer id={MODAL_ID} opacity={30}>
        {({ handleClose, ref }) => (
          <CompanyDeclineModalForm handleClose={handleClose} ref={ref} />
        )}
      </ModalContainer>
    );
  };

export default CompanyDeclineModal;
